import { string, number, ref, type StringSchema, type NumberSchema } from 'yup'

export const emailRequired = (): StringSchema =>
  string()
    .email('Zadejte platný e-mail')
    .required('E-mail je povinný')

export const emailOptional = (): StringSchema =>
  string()
    .email('Zadejte platný e-mail')
    .nullable()
    .notRequired() as StringSchema

export const passwordRequired = (): StringSchema =>
  string()
    .min(8, 'Heslo musí mít alespoň 8 znaků')
    .required('Heslo je povinné')

export const passwordConfirm = (refField: string = 'password'): StringSchema =>
  string()
    .oneOf([ref(refField)], 'Hesla se neshodují')
    .required('Potvrzení hesla je povinné')

export const verificationCode = (): StringSchema =>
  string()
    .matches(/^\d{6}$/, 'Kód musí obsahovat přesně 6 číslic')
    .required('Ověřovací kód je povinný')

export const urlString = (): StringSchema =>
  string()
    .test('url', 'Zadejte platnou URL adresu', (value) => {
      if (!value) return true
      const withProtocol = /^https?:\/\//.test(value) ? value : `https://${value}`
      try {
        new URL(withProtocol)
        return true
      } catch {
        return false
      }
    })
    .nullable()
    .notRequired() as StringSchema

export function normalizeUrl(value: string | null | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed) return null
  return /^https?:\/\//.test(trimmed) ? trimmed : `https://${trimmed}`
}

const CZECH_PHONE_REGEX = /^\+420\s?\d{3}\s?\d{3}\s?\d{3}$/
const CZECH_PHONE_MSG = 'Zadejte platné české telefonní číslo (+420 xxx xxx xxx)'

export const phoneString = (): StringSchema =>
  string()
    .matches(CZECH_PHONE_REGEX, { message: CZECH_PHONE_MSG, excludeEmptyString: true }) as StringSchema

export const feeNumber = (): NumberSchema =>
  number()
    .integer('Zadejte celé číslo')
    .min(0, 'Poplatek nemůže být záporný')
    .nullable()
    .transform((value, original) => (original === '' || original === null || original === undefined ? null : value)) as NumberSchema

export const reviewRating = (): NumberSchema =>
  number()
    .integer('Hodnocení musí být celé číslo')
    .min(1, 'Hodnocení musí být alespoň 1')
    .max(5, 'Hodnocení může být maximálně 5')
    .nullable()
    .transform((value, original) => (original === '' || original === null || original === undefined ? null : value)) as NumberSchema

export const reviewText = (maxLength: number = 2000): StringSchema =>
  string()
    .max(maxLength, `Text může mít maximálně ${maxLength} znaků`)
    .nullable()
    .transform((value) => (value?.trim() || null)) as StringSchema

export const reviewProsCons = (maxLength: number = 500): StringSchema =>
  string()
    .max(maxLength, `Text může mít maximálně ${maxLength} znaků`)
    .nullable()
    .transform((value) => (value?.trim() || null)) as StringSchema

export const feedbackDescription = (): StringSchema =>
  string()
    .trim()
    .min(10, 'Popis musí mít alespoň 10 znaků')
    .max(5000, 'Maximálně 5000 znaků')
    .required('Popis je povinný')
